exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "a.findFriendsCTA-8cfa5f94{padding:20px 0 0 0}\n", ""]);

// Exports
exports.locals = {
	"findFriendsCTA": "findFriendsCTA-8cfa5f94"
};